
export default class HttpStatusCode {
    public static OK: number = 200;
    public static CODE_300 = 300;
    public static BAD_REQUEST: number = 400;
    public static UNAUTHORIZED: number = 401;
    public static NOTFOUND: number = 404;
    public static INTERNAL_SERVER_ERROR: number = 500;
    public static UNKNOW_ERROR = 700
}
